export default "https://cdn-static-unstable.gokick.com/assets/6c6ec7987c723fb20ca76f9d1acc92ca38fc33c2/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";